import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { spacing, H4 } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import {
  ITERABLE,
  SENDING_PLATFORMS_PAGE_TEXT as TEXT,
  SPARKPOST,
  MAILGUN,
  DYN,
  SENDGRID,
  TELNYX,
  TWILIO,
  SendingPlatform,
  ITERABLE_SMS,
  CUSTOM_EMAIL,
  CUSTOM_PUSH,
  WHATS_APP,
} from '../../constants';
import { useSendingPlatformsQueryContext } from '../../contexts';
import { EmailIntegrationCard } from './EmailIntegrationCard';
import { SESIntegrationCard } from './SESIntegrationCard';
import { SmsIntegrationCard } from './SmsIntegrationCard';
import { PushIntegrationCard } from './PushIntegrationCard';

const Header = styled(H4)`
  margin-top: 0;
  margin-bottom: ${spacing.base};
`;

const GridContainer = styled.div`
  display: grid;
  grid-gap: ${spacing.double};
  grid-template-columns: repeat(auto-fill, minmax(${pxToRem(280)}, 1fr));
`;

const IntegrationCardComponentBySendingPlatform = {
  [ITERABLE]: SESIntegrationCard,
  [SPARKPOST]: EmailIntegrationCard,
  [MAILGUN]: EmailIntegrationCard,
  [DYN]: EmailIntegrationCard,
  [SENDGRID]: EmailIntegrationCard,
  [CUSTOM_EMAIL]: EmailIntegrationCard,
  [CUSTOM_PUSH]: PushIntegrationCard,
  [ITERABLE_SMS]: SmsIntegrationCard,
  [TELNYX]: SmsIntegrationCard,
  [TWILIO]: SmsIntegrationCard,
  [WHATS_APP]: EmailIntegrationCard,
};

export const ConnectedPlatformsSection = () => {
  const { connectedPlatforms, isLoadingEssentialData } = useSendingPlatformsQueryContext();

  return (
    <div data-test="connected-platforms-section">
      <Header>{TEXT.CONNECTED_HEADER}</Header>
      {isLoadingEssentialData ? (
        <Skeleton height={112} />
      ) : (
        <GridContainer>
          {connectedPlatforms.map((sendingPlatform) => {
            const Card =
              IntegrationCardComponentBySendingPlatform[sendingPlatform as SendingPlatform];
            return <Card key={sendingPlatform} sendingPlatform={sendingPlatform} />;
          })}
        </GridContainer>
      )}
    </div>
  );
};
